import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  NgZone,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { PolicyService } from '../../../policy/services/policy.service';
import { PolicyQuery } from '../../../policy/state/policy.query';
import { Policy } from '../../models/policy.model';
import { PolicyStore } from '../../../policy/state/policy.store';
import { UserStore } from '../../../authentication/state/user.store';
import { RouterLinks, Superflow } from '../../constants';
import { UnderwriterService } from '../../../underwriter/services/underwriter.service';
import { QuotesService } from 'src/app/modules/quotes/services/quotes.service';
import { GlobalQuestionService } from '../../services/global-question.service';
import { GetPoliciesRequest } from '../../models/get-policies-request.model';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { QuestionFlowSessionStore } from '../../questions/state/question-flow-session.store';
import { ClaimsService } from 'src/app/modules/claim/services/claims.service';
import { ShoppingCartStore } from '../../questions/state/shopping-cart-store';
import { ShoppingCartItem } from '../../models/underwriter.model';
import { PushNotifications } from '@capacitor/push-notifications';
import { Chart, registerables } from 'chart.js';
import { DatePipe } from '@angular/common';
import { StorageService } from '../../services/storage.service';
// import FontFaceObserver from 'fontfaceobserver';
Chart.register(...registerables);

declare var $: any;
declare var accounting: any;
declare var  dateFilter: any;

declare function notify(): any;
declare function initFilters(): any;
declare function initFilterAccordions(): any;
declare function dashChart(): any;
declare function filterList(e: any): any;

declare const FontFaceObserver: any;
declare global {
  interface Window { angularComponentReference: any; }
}

@Component({
    selector: 'app-broker-dashboard',
    templateUrl: './broker-dashboard.component.html',
    styleUrls: ['./broker-dashboard.component.scss'],
    standalone: false
})
export class BrokerDashboardComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  RouterLinks = RouterLinks;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  @ViewChild('viewElement') viewElement: any;
  dtOptions: any = {};
  request = new GetPoliciesRequest();
  person: any;

  tablePolicies: Policy[] = [];
  accounting: any;
  categories: any[] = [];
  notify: any;
  showTableContent = false;
  statusFilterAll = 'All';
  productFilterAll = 'All';
  brokers: any[] = [];
  insurers: any[] = [];
  users: any[] = [];
  broker_id = 0;
  selectedInsurer: any;
  mode = 'Policies';
  search_query = '';
  //searchChanged = new Subject<string>();
  brokerage_ids = [];
  broker_ids = [];
  statuses = [];
  status_ids = [];
  product_ids = [];
  claims = false;
  uwDataset: any;
  uwView = 'Policies';
  sort: string = 'name';
  order: string = 'asc';
  selectedView = 'Policies';
  policies: any;
  underwriting: any;
  underwriting_data: any;
  renewals: any;
  claimsdataset: any;
  quotes: any;
  isEmpty = true;
  indexes = [];
  isDeeper = false;
  isDeeperLabel = '';
  selectedtItem: any;
  graphType = 'line';
  fontSans: any;
  activeChartToggle = 'value';
  dashChartInstance = dashChart();
  dateFrom: string;
  dateTo: string;
  period: string;
  filters: any = [];
  filter_options: any;
  class_csv: any = [];
  category_csv: any = [];
  product_csv: any = [];
  product_group_csv: any = [];
  insurer_csv: any = [];
  broker_user_csv: any = [];
  isFilter = false;
  filterCount = 0;
  moreActiveDesktop = false;
  moreActiveMobile = false;
  selectedDesktopIdx = 0;
  selectedIdx = 0;
  constructor(
    private router: Router,
    private ngZone: NgZone, 
    private datePipe: DatePipe,
    private policyService: PolicyService,
    private userStore: UserStore,
    public quotesService: QuotesService,
    private store: PolicyStore,
    private underwriterService: UnderwriterService,
    public policyQuery: PolicyQuery,
    private claimService: ClaimsService,
    private policyStore: PolicyStore,
    private shoppingCartStore: ShoppingCartStore,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    public globalQuestionService: GlobalQuestionService,
    private storageService: StorageService
  ) {
    const isPolicyRejected =
      this.router.getCurrentNavigation()?.extras?.state?.policyRejected;
    this.notify = notify();
    if (isPolicyRejected) {
      this.underwriterService.notifyToast(
        `Policy ${isPolicyRejected} successfully rejected`,
        'info'
      );
    }
    this.mode = this.storageService.get('mode', 'flow');
  }
  ngOnDestroy(): void {}

  ngOnInit(): void {
    //this.globalQuestionService.spinner(true);
    window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: (date) => this.angularFunctionCalled(date), }; 
    this.person = this.userStore.getValue();
    this.globalQuestionService.setPushToken();
    if (!this.mode) {
      this.mode = 'Policies';
    }
    if (this.person) {
      if (this.person.console_access) {
        this.underwriting = true;
        this.claims = true;
      }
      if (this.person.underwriter) {
        this.underwriting = true;
        this.mode = 'Underwriting';
      }
    }

    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      },
    };
    this.accounting = accounting;
  }
  
  ngAfterViewInit(): void {
    this.setView('Policies');
    
    setTimeout(() => {
      initFilters();
      initFilterAccordions();
      this.initDateFilter();
      this.initGlobalSearch();
      $('#global-search-input').on('keypress', (e) => {
        if (e.which == 13) {
          this.storageService.set('previous-document-page', this.router.url, 'flow');
          this.router.navigateByUrl(`/global-search?q=${e.target.value}`)
        }
      });
    }, 1000);
  }
  activateMore(x: string): void {
    if (x === 'desktop') {
      this.moreActiveDesktop = !this.moreActiveDesktop;
      if (this.moreActiveDesktop) {
        this.selectedDesktopIdx = $('#app-bar-desktop').find('li.is-active').index();
        $('#app-bar-desktop').find('li').eq(this.selectedDesktopIdx).removeClass('is-active');
      }
      else $('#app-bar-desktop').find('li').eq(this.selectedDesktopIdx).addClass('is-active');
    }
    else {
      this.moreActiveMobile = !this.moreActiveMobile;
      if (this.moreActiveMobile) {
        this.selectedIdx = $('#app-bar').find('li.is-active').index();
        $('#app-bar').find('li').eq(this.selectedIdx).removeClass('is-active');
      }
      else $('#app-bar').find('li').eq(this.selectedIdx).addClass('is-active');

    }

  }
  //Nice little hack to pass data from JS to Angular... hehehe
  angularFunctionCalled(dates: any): void{  
    if (this.period === 'custom'){
      this.dateFrom = this.datePipe.transform(dates[0], 'yyyy-MM-dd');
      this.dateTo = this.datePipe.transform(dates[1], 'yyyy-MM-dd'); 
    }
    console.log( this.dateFrom,this.dateTo);
    this.setView(this.selectedView);
  } 
  setPeriod(range: string): void {
    this.period = range;
    switch (this.period) {
      case 'custom':
        return;
        break;
      case 'week':
        this.dateFrom = this.datePipe.transform(new Date((new Date().setDate(new Date().getDate() - 7))), 'yyyy-MM-dd') ;
        this.dateTo = this.datePipe.transform(new Date(), 'yyyy-MM-dd') ;
        break;
      case 'past-month':
        this.dateFrom = this.datePipe.transform(new Date((new Date().setMonth(new Date().getMonth()  - 1))), 'yyyy-MM-dd') ;
        this.dateTo = this.datePipe.transform(new Date(), 'yyyy-MM-dd') ;
        break;
      case 'past-year':
        this.dateFrom = this.datePipe.transform(new Date((new Date().setFullYear(new Date().getFullYear() - 1))), 'yyyy-MM-dd') ;
        this.dateTo = this.datePipe.transform(new Date(), 'yyyy-MM-dd') ;
        break;
      case 'all-time':
        this.dateFrom = '1900-01-01' ;
        this.dateTo = this.datePipe.transform(new Date(), 'yyyy-MM-dd') ;
        break
    }
    console.log( this.dateFrom,this.dateTo);
    this.setView(this.selectedView);
  }
 initDateFilter(): void{
  var dateFilter = (function () {

    var $dateRangeFromField = $('#daterange-from'),
      $dateRangeToField = $('#daterange-to');
  
    var $dateRangeFilterList = $('#date-range-filter-list'),
      $dateRangeDropdownTrigger = $('#daterange-dropdown-trigger'),
      $dateRangeCalendars = $('#daterange-calendars'),
      $dateRangeCalendarFrom = $('#daterange-calendar-from'),
      $dateRangeCalendarTo = $('#daterange-calendar-to');
  
    var $dateRangeApplyBtn = $('#date-range-apply'),
      $dateRangeCancelBtn = $('#date-range-cancel');
  
    var $dateInputFrom,
      $dateInputTo;
  
    var fromDateSelected = false;
    var toDateSelected = false;
  
    var dateFormat = "dd M, yy";
    var formatedFromDate = '';
    var formatedToDate = '';
  
    var customActive = false;
    var dropdownTriggerState = {
      selected: $dateRangeFilterList.find('input[name="date-range[]"]:checked').val(),
      dateFrom: null,
      dateTo: null
    };
    
  
    function init() {
  
      dateRangeSelectListener();
      applyFilterListener();
      cancelFilterListener();
  
      // date range pickers
      initInlinePickerDatepickers();
  
      // dropdown events
      $('#daterange-dropdown').on('show.bs.dropdown', function (e) {
        // set date filter radio to last selected item
       
        $dateRangeFilterList.find('input[name="date-range[]"][value="' + dropdownTriggerState.selected + '"]').prop('checked', true);
        // if selected item was custom range, show date picker
        if (dropdownTriggerState.selected === 'custom') setTriggerStateCustom('pick');
      });
  
      // $('#daterange-dropdown').on('hide.bs.dropdown', function (e) {
      // });
  
    }
  
    function toggleApplyButtonState(value) {
      $dateRangeApplyBtn.attr('disabled', dropdownTriggerState.selected === value)
    }
  
  
    function handleDateFromClick() {
      $dateRangeFromField.addClass('is-active');
      $dateRangeToField.removeClass('is-active');
  
      $dateRangeCalendarFrom.addClass('is-active');
      $dateRangeCalendarTo.removeClass('is-active');
    }
  
    function handleDateToClick() {
      $dateRangeFromField.removeClass('is-active');
      $dateRangeToField.addClass('is-active');
  
      $dateRangeCalendarFrom.removeClass('is-active');
      $dateRangeCalendarTo.addClass('is-active');
    }
  
  
    function setTriggerStateCustom(state) {
  
      $dateRangeDropdownTrigger.addClass('is-range');
  
      if (state === 'pick') {
  
        // if no custom date range previously stored...
        if (dropdownTriggerState.dateFrom === null) {
          $dateRangeFromField.text('Date From');
          $dateRangeToField.text('Date To');
        }
  
        // disable apply button
        $dateRangeApplyBtn.attr('disabled', true)
  
        // show calendar
        $dateRangeCalendars.addClass('is-active');
  
        // from and to listeners
        $dateRangeFromField.on('click', function (e) {
          e.stopPropagation();
          handleDateFromClick();
        });
  
        $dateRangeToField.on('click', function (e) {
          e.stopPropagation();
          handleDateToClick();
        });
  
  
        $dateRangeFromField.addClass('is-active');
        $dateRangeToField.removeClass('is-active');
  
        $dateRangeCalendars.addClass('is-active');
        $dateRangeCalendarFrom.addClass('is-active');
        $dateRangeCalendarTo.removeClass('is-active');
  
        $dateRangeDropdownTrigger.removeClass('is-selected');
  
        $dateRangeFromField.removeClass('is-set');
        $dateRangeToField.removeClass('is-set');
  
  
      } else if (state === 'selected') {
  
        $dateRangeFromField.removeClass('is-active');
        $dateRangeToField.removeClass('is-active');
  
        $dateRangeCalendars.removeClass('is-active');
  
        $dateRangeDropdownTrigger.addClass('is-selected');
  
      }
  
      $dateRangeDropdownTrigger.dropdown('update');
  
    }
  
    function setTriggerStateDefault() {
  
      $dateRangeDropdownTrigger
        .removeClass('is-range')
        .removeClass('is-selected');
      $dateRangeToField.removeClass('is-active');
      $dateRangeFromField.removeClass('is-active');
  
      $dateRangeFromField.off('click');
      $dateRangeToField.off('click');
  
      $dateRangeCalendars.removeClass('is-active');
      $dateRangeDropdownTrigger.removeClass('is-range');
      $dateRangeFromField.removeClass('is-active');
      $dateRangeToField.removeClass('is-active');
  
      var $selectedFilter = $dateRangeFilterList.find('input[name="date-range[]"][value="' + dropdownTriggerState.selected + '"]');
      $dateRangeFromField.text($selectedFilter.attr('data-title'));
  
      $dateRangeDropdownTrigger.dropdown('update');
  
  
  
    }
  
  
    function onDateRangeSelect(activate, value) {
  
      toggleApplyButtonState(value);
  
      // if custom date active
      if (activate) {
        setTriggerStateCustom('pick');
      }
  
      // if custom date not active
      if (!activate) {
  
        // if custom is currently selected filter
        if (dropdownTriggerState.selected === 'custom') {
          setTriggerStateCustom('selected');
        } else {
          setTriggerStateDefault();
        }
  
      }
  
  
    }
  
    function dateRangeSelectListener() {
  
      $dateRangeFilterList.find('input[name="date-range[]"]').on('change', function () {
        var $this = $(this);
        customActive = $this.is(":checked") && $this.val() === 'custom';
        onDateRangeSelect(customActive, $this.val());
      });
  
  
      // work-around for bug causing dropdown to close when clicking prev/next month buttons
      // disable hiding dropdown whilst custom range datepicker open
      $('#daterange-dropdown').on('hide.bs.dropdown', function (e) {
        return !customActive;
      });
  
      $('#date-range-apply, #date-range-cancel').on('click', function () {
        customActive = false;
      });
  
    }
  
    function applyFilterListener() {
      $dateRangeApplyBtn.on('click', function () {
  
        var $selectedFilter = $dateRangeFilterList.find('input[name="date-range[]"]:checked');
        var selectedVal = $selectedFilter.val();
  
        toggleApplyButtonState(selectedVal);
  
        toDateSelected = false;
        fromDateSelected = false;
  
        dropdownTriggerState.selected = selectedVal;
  
  
        if (selectedVal === 'custom') {
          $('#date-filtered-log').html('Date filter range: <strong>' + formatedFromDate + '</strong> to <strong>' + formatedToDate + '</strong>')
          var dates = [formatedFromDate,formatedToDate];
          window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(dates); });
          dropdownTriggerState.dateFrom = $dateInputFrom.datepicker('getDate');
          dropdownTriggerState.dateTo = $dateInputTo.datepicker('getDate');
  
          setTriggerStateCustom('selected');
  
  
        } else {
          $('#date-filtered-log').html('Date filtered by: <strong>' + selectedVal + '</strong>')
  
          dropdownTriggerState.dateFrom = null;
          dropdownTriggerState.dateTo = null;
  
          $dateRangeFromField.text($selectedFilter.attr('data-title'));
  
          setTriggerStateDefault();
        }
  
  
      });
  
    }
  
    function cancelFilterListener() {
  
  
  
      $dateRangeCancelBtn.on('click', function () {
        if (dropdownTriggerState.selected === 'custom') {
          setTriggerStateCustom('selected');
        } else {
          setTriggerStateDefault();
        }
      });
  
    }
  
    function initInlinePickerDatepickers() {
      $dateInputFrom = $('#filter-daterange-inline-from')
        .datepicker({
          defaultDate: '',
          dateFormat: dateFormat,
          dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          numberOfMonths: 1,
          showOn: "both",
          buttonText: "",
          altField: "#filter-daterange-inline-from-input",
          altFormat: dateFormat,
          showOtherMonths: true,
          showOptions: {
            direction: "down",
          },
          changeMonth: true,
          changeYear: true
        })
        .on("change", function () {
  
          var fromDate = $dateInputFrom.datepicker('getDate');
          fromDateSelected = true;
          $dateInputTo.datepicker("option", "minDate", fromDate);
  
          if (fromDateSelected && toDateSelected) {
            $dateRangeApplyBtn.attr('disabled', false);
          }
  
          formatedFromDate = $('#filter-daterange-inline-from').datepicker({ dateFormat: dateFormat }).val();
          $dateRangeFromField.text(formatedFromDate);
          $dateRangeFromField.addClass('is-set');
  
          if (!toDateSelected) handleDateToClick();
  
          $dateRangeDropdownTrigger.dropdown('update');
  
        });
  
      $dateInputTo = $('#filter-daterange-inline-to')
        .datepicker({
          defaultDate: '+1w',
          dateFormat: dateFormat,
          dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          numberOfMonths: 1,
          showOn: "both",
          buttonText: "",
          altField: "#filter-daterange-inline-to-input",
          altFormat: dateFormat,
          showOtherMonths: true,
          showOptions: {
            direction: "down",
          },
          changeMonth: true,
          changeYear: true
        })
        .on("change", function () {
  
          var toDate = $dateInputTo.datepicker('getDate');
          toDateSelected = true;
          $dateInputFrom.datepicker("option", "maxDate", toDate);
  
          if (fromDateSelected && toDateSelected) {
            $dateRangeApplyBtn.attr('disabled', false);
          }
  
          formatedToDate = $('#filter-daterange-inline-to').datepicker({ dateFormat: dateFormat }).val();
          $dateRangeToField.text(formatedToDate);
          $dateRangeToField.addClass('is-set');
  
          if (!fromDateSelected) handleDateFromClick();
  
          $dateRangeDropdownTrigger.dropdown('update');
  
        });
      
    }
  
    return {
      init: init,
    };
  })();
  dateFilter.init();
 }
  changeMode(mode: string): void {
    this.storageService.set('mode', mode, 'flow');
    this.router.navigate(['/' + RouterLinks.PolicyHolders]);
  }
  setView(view: string): void {
    this.isEmpty = true;
    this.selectedView = view;
    this.indexes = [];
    const parameters = new Map<string, string>();
    // parameters.set("broker_user_id", this.person.person_id);
    // parameters.set("broker_id", this.person.broker_id);
    parameters.set("broker_user_id", this.person?.person_id.toString());
    parameters.set("broker_id", "1");
    if (this.dateFrom !== '') parameters.set("begin_date",this.dateFrom);
    if (this.dateTo !== '') parameters.set("end_date",this.dateTo);
    if (this.class_csv.toString() !== '') parameters.set("class_csv",this.class_csv.toString());
    if (this.category_csv.toString() !== '') parameters.set("category_csv",this.category_csv.toString());
    if (this.product_group_csv.toString() !== '')  parameters.set("product_group_csv",this.product_group_csv.toString());
    if (this.insurer_csv.toString() !== '') parameters.set("insurer_csv",this.insurer_csv.toString());
    if (this.broker_user_csv.toString() !== '') parameters.set("broker_user_csv",this.broker_user_csv.toString());
    if (this.selectedView === 'Policies') {
      this.globalQuestionService.spinner(true);
      this.globalQuestionService
        .runCommandNew(`getDashboardPolicy`, parameters, true)
        .subscribe((dataset) => {
          console.log(dataset);
          for (let i=0; i < dataset.length; i++){
            if (!this.indexes.includes(dataset[i][0]?.index_1))
              this.indexes.push(dataset[i][0]?.index_1);
          }
          this.policies = dataset;
          if (this.indexes.length > 0) this.isEmpty = false;
          this.globalQuestionService.spinner(false);
        });
    } else if (this.selectedView === 'Quotes') {
      this.globalQuestionService.spinner(true);
      this.globalQuestionService
        .runCommandNew(`getDashboardQuotes`, parameters, true)
        .subscribe((dataset) => {
          
          for (let i=0; i < dataset.length; i++){
            if (!this.indexes.includes(dataset[i][0]?.index_1))
              this.indexes.push(dataset[i][0]?.index_1);
          }
          this.quotes = dataset;
          if (this.indexes.length > 0) this.isEmpty = false;
          this.globalQuestionService.spinner(false);
        });
      
    } else if (this.selectedView === 'Renewals') {
      this.globalQuestionService.spinner(true);
      this.globalQuestionService
        .runCommandNew(`getDashboardRenewals`, parameters, true)
        .subscribe((dataset) => {
          for (let i=0; i < dataset.length; i++){
            if (!this.indexes.includes(dataset[i][0]?.index_1))
              this.indexes.push(dataset[i][0]?.index_1);
          }
          console.log(dataset);
          this.renewals = dataset;
          if (this.indexes.length > 0) this.isEmpty = false;
          this.globalQuestionService.spinner(false);
        });
    } else if (this.selectedView === 'Claims') {
      this.globalQuestionService.spinner(true);
      this.globalQuestionService
        .runCommandNew(`getDashboardClaims`, parameters, true)
        .subscribe((dataset) => {
          for (let i=0; i < dataset.length; i++){
            if (!this.indexes.includes(dataset[i][0]?.index_1))
              this.indexes.push(dataset[i][0]?.index_1);
          }
          console.log(dataset);
          this.claimsdataset = dataset;
          if (this.indexes.length > 0) this.isEmpty = false;
          this.globalQuestionService.spinner(false);
        });
    }  else if (this.selectedView === 'Underwriting') {
      this.globalQuestionService.spinner(true);
      this.globalQuestionService
        .runCommandNew(`getDashboardUnderwriting`, parameters, true)
        .subscribe((dataset) => {
          for (let i=0; i < dataset.length; i++){
            if (!this.indexes.includes(dataset[i][0]?.index_1))
              this.indexes.push(dataset[i][0]?.index_1);
          }
          console.log(dataset);
          this.underwriting_data = dataset;
          if (this.indexes.length > 0) this.isEmpty = false;
          this.globalQuestionService.spinner(false);
        });
    } else {
      this.globalQuestionService.spinner(false);
    }
    if (!this.isFilter) {
      const param = new Map<string, string>();
      // param.set("broker_user_id", '1446');
      // param.set("broker_id", '1006');
      param.set("broker_user_id", this.person.person_id);
      param.set("broker_id", this.person.broker_id);
      this.globalQuestionService
        .runCommandNew(`getDashboardFilter`, param, true)
        .subscribe((filters) => {
          this.filter_options = filters[0];
          this.filter_options.forEach(el => {

            if (!this.filters.some(f => f['filter_header'] === el.filter_header)) {
              this.filters.push(el)
            }
          });
          console.log(this.filters, this.filter_options);
          setTimeout(() => {
            $('[data-input="search-filter"]').each(function () {
              $(this).on('input', filterList);
            });
          }, 2000);
        })
    }
  }
  getFilters(f:any): any {
    return this.filter_options.filter( e => e.filter_header === f.filter_header)
  }
  setFilter($event: any, filter: any, item: any): void {
    console.log($event.srcElement.checked, filter, item);
    switch (filter?.filter_header) {
      case 'Class':
        if ($event.srcElement.checked) {
          if (!this.class_csv.includes(item.filter_value)) {
            this.class_csv.push(item?.filter_value);
          }
        }
        else {
          this.class_csv.splice(this.class_csv.findIndex(v => v.filter_value === item.filter_value), 1);
        }
        break;
      case 'Category':
        if ($event.srcElement.checked) {
          if (!this.category_csv.includes(item.filter_value)) {
            this.category_csv.push(item?.filter_value);
          }
        }
        else {
          this.category_csv.splice(this.category_csv.findIndex(v => v.filter_value === item.filter_value), 1);
        }
        break;
      case 'Insurer':
        if ($event.srcElement.checked) {
          if (!this.insurer_csv.includes(item.filter_value)) {
            this.insurer_csv.push(item?.filter_value);
          }
        }
        else {
          this.insurer_csv.splice(this.insurer_csv.findIndex(v => v.filter_value === item.filter_value), 1);
        }
        break;
      case 'Product Group':
        if ($event.srcElement.checked) {
          if (!this.product_group_csv.includes(item.filter_value)) {
            this.product_group_csv.push(item?.filter_value);
          }
        }
        else {
          this.product_group_csv.splice(this.product_group_csv.findIndex(v => v.filter_value === item.filter_value), 1);
        }
        break;
      case 'Teams':
        if ($event.srcElement.checked) {
          if (!this.broker_user_csv.includes(item.filter_value)) {
            this.broker_user_csv.push(item?.filter_value);
          }
        }
        else {
          this.broker_user_csv.splice(this.broker_user_csv.findIndex(v => v.filter_value === item.filter_value), 1);
        }
        break;
    }
  }
  setAllFilter(f: any): void {
    $(`.${f?.filter_value}-filters`).each( (i: number,e: any) => {
      e.click()
    })
  }
  resetFilters(): void {
    let checkboxes = document.querySelectorAll('input[type="checkbox"]');
    $(checkboxes).each( (i: number,e: any) => {
      e.checked = false;
    })
    this.class_csv = [];
    this.category_csv = [];
    this.product_group_csv = [];
    this.insurer_csv = [];
    this.broker_user_csv = [];
    this.filterCount = 0;
    this.isFilter = false;
    console.log(this.filterCount)
  }
  applyFilters(): void{
    this.isFilter = true;
    this.filterCount = this.class_csv.length + this.category_csv.length + this.product_group_csv.length + this.insurer_csv.length + this.broker_user_csv.length;
    this.setView(this.selectedView);
  }
  getIndexChidren(index: number): any {
    let array = [];

    switch (this.selectedView) {
      case "Policies":
        if (this.policies) {
          for (let i = 0; i < this.policies.length; i++) {
            this.policies[i].forEach(el => {
              if (el.index_1 === index && el.index_3 === 0) {
                array.push(el);
              }
            });

          }
        };
        break;
      case "Quotes":
        if (this.quotes) {
          for (let i = 0; i < this.quotes.length; i++) {
            this.quotes[i].forEach(el => {
              if (el.index_1 === index && el.index_3 === 0) {
                array.push(el);
              }
            });

          }
        };
        break;
      case "Renewals":
        if (this.renewals) {
          for (let i = 0; i < this.renewals.length; i++) {
            this.renewals[i].forEach(el => {
              if (el.index_1 === index && el.index_3 === 0) {
                array.push(el);
              }
            });

          }
        };
        break;
      case "Claims":
        if (this.claimsdataset) {
          for (let i = 0; i < this.claimsdataset.length; i++) {
            this.claimsdataset[i].forEach(el => {
              if (el.index_1 === index && el.index_3 === 0) {
                array.push(el);
              }
            });

          }
        };
        break;
      case "Underwriting":
        if (this.underwriting) {
          for (let i = 0; i < this.underwriting_data.length; i++) {
            this.underwriting_data[i].forEach(el => {
              if (el.index_1 === index && el.index_3 === 0) {
                array.push(el);
              }
            });

          }
        };
        break;

    }
    
    return array;
  }
 
  getPolicyIndex(idx1: number, idx2: number): any {
    let array = [];
    if (this.policies) {
      for (let i=0; i < this.policies.length; i++){
        this.policies[i].forEach(el => {
          if (el.index_1 === idx1 && el.index_2 === idx2){
            try{
              el.parameters = JSON.parse(el?.parameters)[0];
            }
            catch{}
            array.push(el);
          }
        });
      }
    }
    return array;
  }
  getUnderwritingIndex(index: number): any {
    console.log(this.underwriting_data)
    if (this.underwriting && this.underwriting_data) {
      if (index < 4) {
        return [this.underwriting_data[index][0]];
      } else {
        return this.underwriting_data[index];
      }
    }
  }
  getQuoteIndex(idx1: number, idx2: number): any {
    let array = [];
    if (this.quotes) {
      for (let i=0; i < this.quotes.length; i++){
        this.quotes[i].forEach(el => {
          if (el.index_1 === idx1 && el.index_2 === idx2){
            try{
              el.parameters = JSON.parse(el?.parameters)[0];
            }
            catch{}
            array.push(el);
          }
        });
      }
    }
    return array;
  }
  deeperGraph(item: any, index: number, type: string): void {
   
    let chartLabels = [];
    let chartValues = [];
    let array = [];
    let tValue = 'number';
    switch (type) {
      case 'policies':
        
        for (let i = 0; i < this.policies.length; i++) {
          this.policies[i].forEach(el => {
            if (el.index_1 === index && el.index_2 === item?.index_2 && el.index_3 !== 0) {
              array.push(el);
            }
            else if (el.index_1 === index && el.index_2 === item?.index_2 && el.index_3 === 0){
              this.isDeeperLabel = el.label;
              console.log(this.isDeeperLabel)
            }
          });
        }
        this.selectedtItem = array;
        this.selectedtItem.forEach(el => {
          if (el.index_3 !== 0) {
            chartLabels.push(el.entry_date);
            chartValues.push(el.value);
          }
        });
        break;
        case 'quotes':
          
          for (let i = 0; i < this.quotes.length; i++) {
            this.quotes[i].forEach(el => {
              if (el.index_1 === index && el.index_2 === item?.index_2 && el.index_3 !== 0) {
                array.push(el);
              }
              else if (el.index_1 === index && el.index_2 === item?.index_2 && el.index_3 === 0){
                this.isDeeperLabel = el.label;
                console.log(this.isDeeperLabel)
              }
            });
          }
          this.selectedtItem = array;
          this.selectedtItem.forEach(el => {
            if (el.index_3 !== 0) {
              chartLabels.push(el.entry_date);
              chartValues.push(el.value);
            }
          });
          break;
    }
    
    if (chartLabels.length > 0) {
      let data = {
          labels: this.selectedtItem.map(row => row.entry_date),
          datasets: [
            {
              label: this.selectedtItem[0]?.description,
              data: this.selectedtItem.map(row => row.value),
            },
          ],
      }
      this.graphType = item?.display_type;
      if (chartLabels.length > 0){
        this.isDeeper = true;
        this.setupDashCharts(Chart, data, this.graphType);
      }
      
    }
    else {
      this.graphType = 'list';
    }
  }

  setupDashCharts(Chart: any, chartData: any, graphType : string): void {
    // LINE CHART init
    // listen for fonts loaded and render chart
    console.log(chartData)
    this.fontSans = new FontFaceObserver('DM Sans');
    this.fontSans.load().then(() => {
      this.dashChartInstance.init(Chart, {
        type: graphType,
        canvasId: '#lineChart',
        data: chartData,
        //toggleValue: 'number', // initial value from the toggle state
        legendId: '#lineChartLegend',
      });
    });
  }

  toggleDashChart(value): void {
    this.activeChartToggle = value;

    this.dashChartInstance.update({
      type: 'line',
      data: null,
      //toggleValue: this.activeChartToggle,
      brokersActive: false,
    });
  }
  initGlobalSearch(): void {

    var $globalSearch = $("#global-search");
    var $globalSearchInput = $("#global-search-input");
    var $globalSearchClear = $("#global-search-clear");
    var $globalSearchAdvancedTrigger = $("#global-search-advanced");
    var $globalSearchAdvancedModal = $("#advanced-search-modal");
  
  
    // Autocomplete init
    var options = {
      url: function (phrase) {
        return "/assets/global-search-data.json?phrase=" + phrase;
      },
      listLocation: "items",
      getValue: "name",
  
      // matchResponseProperty: "inputPhrase", 
      // enable matchResponseProperty attribute ...the response should include the inputPhrase value (see example in json) to match the incoming request
      // this will ensure we get back the correct request (see: http://easyautocomplete.com/guide#sec-async)         
      requestDelay: 350,  // only perform requests 350ms after each input
      minCharNumber: 2, // will only begin requests if 2 or more characters in input           
  
      template: {
        type: "custom",
        method: function (value, item) {
          console.log(value)
          return "<svg class='icon'><use xlink:href='#" + item.iconId + "'></use></svg><span>" + value + "</span><small>" + item.type + "</small>";
        }
      },
  
      // custom settings to show input value as a 'search all' result
      includePartial: true,
      partialValue: "name",
      partialTemplate: [
        { type: "‒ search all results" },
        { iconId: "search-all" }
      ],
      // end custom settings
  
      adjustWidth: false,
      list: {
        match: {
          enabled: true // show only matched items
        },
        sort: {
          enabled: false
        },
        maxNumberOfElements: 0,
        onLoadEvent: function () {
  
        },
        onShowListEvent: function () {
          $globalSearch.addClass('has-result');
          $('body').addClass('modal-open');
        },
        onHideListEvent: function () {
          $globalSearch.removeClass('has-result');
          $('body').removeClass('modal-open');
        },
        onChooseEvent: function () {
          var value = $globalSearchInput.getSelectedItemData().name;
          var url = location.href.replace('everything.policy-holders','global-search');
          console.log(url)
          location.href = `${url}?q=${value}`;
        },
      }
    };
  
    $globalSearchInput.easyAutocomplete(options);
  
  
    $globalSearchInput
      .on('focus', function () {
        $globalSearch.addClass('is-expanded');
      })
      .on('blur', function () {
        if ($(this).val().length == 0) {
          $globalSearch.removeClass('is-expanded');
        }
      })
      .on('change', function () {
        if ($(this).val().length == 0) {
          $globalSearch.removeClass('is-expanded');
          $globalSearchClear.removeClass('is-active');
        }
      })
      .on('input', function () {
        // show/hide clear button
        if ($(this).val().length > 0) {
          $globalSearchClear.addClass('is-active');
        } else {
          $globalSearchClear.removeClass('is-active');
        }
      });
  
  
    // mobile search trigger & focus search input
    $('#global-search-trigger').on('click', function (e) {
      e.preventDefault();
      $globalSearch.addClass('is-active');
      $globalSearchInput.trigger('focus');
  
  
      // listen for outside clicks and close
      $(document).on('click.outsideglobalsearch', function (e) {
        var $target = $(e.target);
        if (!$target.closest("#global-search").length
          && !$target.closest("#global-search-trigger").length
          && $globalSearchInput.val() === '') {
          $globalSearch.removeClass('is-active');
        }
      });
  
    });
  
    // mobile search back and clear search input
    $('#global-search-back').on('click', function (e) {
      e.preventDefault();
      $globalSearch.removeClass('is-active');
      $globalSearchInput.val("").trigger('input');
  
      $(document).off('click.outsideglobalsearch');
    });
  
    // demo carry global search input value into advanced search modal
    $globalSearchAdvancedModal.on('shown.bs.modal', function (e) {
      $('#advanced-search-keyword')
        .trigger('focus')
        .val($globalSearchInput.val());
  
      // ensure modal is scrolled to top
      $('body').addClass('modal-open');
    });
  
  
    function resetAdvancedSearchForm(){
      $('#advanced-search-form').trigger('reset');
      //$('#advanced-search-submit').attr('disabled', true);
      //$('#advanced-search-clear').attr('disabled', true);
    }
  
    // demo clear advanced search form resest on global search clear
    $globalSearchClear.on('click', function(){
      resetAdvancedSearchForm();
    });
  
    // demo clear advanced search form on modal open
    $globalSearchAdvancedModal.on('show.bs.modal', function () {
      resetAdvancedSearchForm();
    });
  
    // demo clear advanced search form on reset click
    $('#advanced-search-clear').on('click', function (e) {
      e.preventDefault();
      resetAdvancedSearchForm();      
    });
  
  
  }
}
